export const ui = {
  skip: { en: 'Skip to content', es: 'Saltar al contenido' },
  tagline: { en: 'Commercial & Residential Painting', es: 'Pintura Comercial y Residencial' },
  freeEstimate: { en: 'Free Estimate', es: 'Presupuesto Gratis' },
  requestEstimate: { en: 'Request Free Estimate', es: 'Solicitar Presupuesto Gratis' },
  call: { en: 'Call', es: 'Llame al' },
  callNow: { en: 'Call Now', es: 'Llamar' },
  hoursShort: { en: 'Open 7 days · 9am – 7pm', es: 'Abierto 7 días · 9am – 7pm' },
  hoursLong: { en: 'Monday – Sunday, 9:00 AM – 7:00 PM', es: 'Lunes a domingo, 9:00 AM – 7:00 PM' },
  openMenu: { en: 'Open menu', es: 'Abrir menú' },
  closeMenu: { en: 'Close menu', es: 'Cerrar menú' },
  language: { en: 'Language', es: 'Idioma' },
  onGoogle: { en: 'on Google', es: 'en Google' },
  licensed: { en: 'Licensed & insured', es: 'Con licencia y seguro' },
  home: { en: 'Win21der home', es: 'Inicio de Win21der' },
  commercial: { en: 'Commercial', es: 'Comercial' },
  residential: { en: 'Residential', es: 'Residencial' },

  meta: {
    title: {
      en: 'Painting Services Columbus OH | Commercial & Residential | Win21der',
      es: 'Pintores en Columbus, OH | Comercial y Residencial | Win21der',
    },
    description: {
      en: 'Professional painting services in Columbus, Ohio for homes and businesses. Interior & exterior painting, drywall repair, specialty coatings. Free estimate. 614-382-9458.',
      es: 'Pintura profesional en Columbus, Ohio para hogares y negocios. Interior y exterior, reparación de drywall y recubrimientos. Presupuesto gratis: 614-382-9458.',
    },
  },

  hero: {
    title: {
      en: 'Professional Painting Services in Columbus, Ohio',
      es: 'Servicios Profesionales de Pintura en Columbus, Ohio',
    },
    subtitle: {
      en: 'Commercial & Residential Painting Excellence',
      es: 'Excelencia en Pintura Comercial y Residencial',
    },
    description: {
      en: 'Expert painting solutions for your home or business. From residential room painting to large commercial projects, Win21der delivers professional results. Licensed, insured, trusted by Columbus families and businesses.',
      es: 'Soluciones expertas de pintura para su hogar o negocio. Desde pintar una habitación hasta grandes proyectos comerciales, Win21der entrega resultados profesionales. Con licencia, asegurados y de confianza para familias y negocios de Columbus.',
    },
    imageAlt: {
      en: 'Professional painter rolling navy paint on a wall — commercial and residential painting in Columbus, Ohio',
      es: 'Pintor profesional pintando una pared — pintura comercial y residencial en Columbus, Ohio',
    },
  },

  why: {
    title: {
      en: 'Why Choose Win21der for Your Painting Project?',
      es: '¿Por qué elegir Win21der para su proyecto de pintura?',
    },
    body: {
      en: "Win21der is a locally owned painting company based in Columbus, Ohio. We specialize in both commercial and residential painting services. Whether you're painting a single room at home or a large commercial property, we deliver consistent, high-quality results with integrity and attention to detail.",
      es: 'Win21der es una empresa local de pintura con sede en Columbus, Ohio. Nos especializamos en pintura comercial y residencial. Ya sea que necesite pintar una sola habitación en casa o una gran propiedad comercial, entregamos resultados consistentes y de alta calidad, con integridad y atención al detalle.',
    },
    owner: {
      en: 'Owned and led by Pablo Adame — on every job, in English or Spanish.',
      es: 'Dirigida por su dueño, Pablo Adame — presente en cada proyecto, en inglés o en español.',
    },
    rating: { en: 'Google rating', es: 'Calificación en Google' },
    days: { en: 'Days a week', es: 'Días a la semana' },
    cities: { en: 'Cities served', es: 'Ciudades atendidas' },
  },

  services: {
    title: { en: 'Painting Services for Homes & Businesses', es: 'Servicios de Pintura para Hogares y Negocios' },
    subtitle: {
      en: 'Complete painting solutions — Commercial & Residential',
      es: 'Soluciones completas de pintura — Comercial y Residencial',
    },
    tabsLabel: { en: 'Choose a service type', es: 'Elija un tipo de servicio' },
    tabCommercial: { en: 'Commercial Painting', es: 'Pintura Comercial' },
    tabResidential: { en: 'Residential Painting', es: 'Pintura Residencial' },
    forCommercial: { en: 'For Commercial Properties', es: 'Para Propiedades Comerciales' },
    forHome: { en: 'For Your Home', es: 'Para Su Hogar' },
    commercialIntro: {
      en: 'Offices, warehouses, retail, schools, churches, and multi-unit properties — painted around your business hours.',
      es: 'Oficinas, almacenes, comercios, escuelas, iglesias y propiedades multifamiliares — pintadas según el horario de su negocio.',
    },
    residentialIntro: {
      en: 'One room or the whole house, inside and out — with careful protection of your furniture, floors, and landscaping.',
      es: 'Una habitación o toda la casa, por dentro y por fuera — protegiendo con cuidado sus muebles, pisos y jardín.',
    },
    learnMore: { en: 'Learn More', es: 'Ver más' },
    showLess: { en: 'Show Less', es: 'Ver menos' },
    getEstimate: { en: 'Get an estimate', es: 'Pedir presupuesto' },
    mostRequested: { en: 'Most requested', es: 'El más solicitado' },
  },

  areas: {
    title: { en: 'Service Areas Across Ohio', es: 'Áreas de Servicio en Ohio' },
    subtitle: {
      en: 'We serve businesses and homeowners throughout Columbus and surrounding communities',
      es: 'Atendemos negocios y hogares en todo Columbus y sus comunidades cercanas',
    },
    intro: {
      en: 'Win21der provides professional painting services to businesses AND homeowners throughout Columbus, Ohio and the greater metropolitan area. Our team is ready to serve commercial properties AND residential homes in all surrounding areas.',
      es: 'Win21der ofrece servicios profesionales de pintura a negocios Y propietarios de vivienda en todo Columbus, Ohio y el área metropolitana. Nuestro equipo está listo para atender propiedades comerciales Y hogares en todas las zonas cercanas.',
    },
    note: {
      en: 'Contact us to confirm service availability for your location.',
      es: 'Contáctenos para confirmar la disponibilidad en su ubicación.',
    },
    cta: { en: 'Check availability for your location', es: 'Verifique disponibilidad en su zona' },
    panelTitle: { en: 'Painting services in {city}, Ohio', es: 'Servicios de pintura en {city}, Ohio' },
    panelCta: { en: 'Request a painting estimate in {city}', es: 'Solicite un presupuesto en {city}' },
    citiesLabel: { en: 'Cities we serve', es: 'Ciudades que atendemos' },
  },

  industries: {
    title: { en: 'Who We Serve', es: 'A Quién Servimos' },
    subtitle: {
      en: 'Painting solutions for businesses and homeowners across Central Ohio',
      es: 'Soluciones de pintura para negocios y propietarios en el centro de Ohio',
    },
    commercialTitle: { en: 'Businesses & Commercial Properties', es: 'Negocios y Propiedades Comerciales' },
    residentialTitle: { en: 'Homeowners & Residential Properties', es: 'Propietarios y Propiedades Residenciales' },
  },

  process: {
    title: { en: 'Our Professional Process', es: 'Nuestro Proceso Profesional' },
    subtitle: {
      en: 'Four clear steps from first call to final walkthrough',
      es: 'Cuatro pasos claros, desde la primera llamada hasta la inspección final',
    },
  },

  testimonials: {
    title: { en: 'What Our Clients Say', es: 'Lo que dicen nuestros clientes' },
    subtitle: {
      en: 'Businesses and homeowners across Columbus share their experience',
      es: 'Negocios y familias de Columbus comparten su experiencia',
    },
  },

  faq: {
    title: { en: 'Frequently Asked Questions', es: 'Preguntas Frecuentes' },
    subtitle: {
      en: 'Straight answers for homeowners and businesses about painting with Win21der.',
      es: 'Respuestas claras para hogares y negocios sobre pintar con Win21der.',
    },
    groups: {
      general: { en: 'General', es: 'Generales' },
      commercial: { en: 'Commercial Painting', es: 'Pintura Comercial' },
      residential: { en: 'Residential Painting', es: 'Pintura Residencial' },
      more: { en: 'Estimates & Service Areas', es: 'Presupuestos y Áreas de Servicio' },
    },
    switchLang: { en: 'Ver preguntas en español', es: 'View questions in English' },
    stillQuestions: { en: 'Have another question?', es: '¿Tiene otra pregunta?' },
    stillBody: {
      en: 'Call us or send a message — we answer in English and Spanish.',
      es: 'Llámenos o envíenos un mensaje — atendemos en inglés y en español.',
    },
    contactLink: { en: 'Send us a message', es: 'Envíenos un mensaje' },
  },

  gallery: {
    title: { en: 'Our Work', es: 'Nuestro Trabajo' },
    subtitle: {
      en: 'Professional painting projects — Commercial & Residential. Drag the slider to compare.',
      es: 'Proyectos profesionales de pintura — Comercial y Residencial. Deslice para comparar.',
    },
    tabsLabel: { en: 'Choose a project type', es: 'Elija un tipo de proyecto' },
    tabCommercial: { en: 'Commercial Projects', es: 'Proyectos Comerciales' },
    tabResidential: { en: 'Residential Projects', es: 'Proyectos Residenciales' },
    before: { en: 'Before', es: 'Antes' },
    after: { en: 'After', es: 'Después' },
    drag: { en: 'Drag to compare before and after: {title}', es: 'Deslice para comparar antes y después: {title}' },
  },

  contact: {
    title: { en: 'Ready to Transform Your Home or Business?', es: '¿Listo para transformar su hogar o negocio?' },
    subtitle: {
      en: 'Tell us about your painting project. We reply with a free written estimate within one business day.',
      es: 'Cuéntenos sobre su proyecto de pintura. Le respondemos con un presupuesto escrito gratuito en un día hábil.',
    },
    formLabel: { en: 'Free painting estimate request', es: 'Solicitud de presupuesto de pintura' },
    name: { en: 'Full name', es: 'Nombre completo' },
    phone: { en: 'Phone', es: 'Teléfono' },
    email: { en: 'Email', es: 'Correo electrónico' },
    projectType: { en: 'Project type', es: 'Tipo de proyecto' },
    location: { en: 'Project location', es: 'Ubicación del proyecto' },
    timeline: { en: 'Preferred timeline', es: 'Plazo preferido' },
    language: { en: 'Preferred language', es: 'Idioma preferido' },
    details: { en: 'Project details (optional)', es: 'Detalles del proyecto (opcional)' },
    select: { en: 'Select an option', es: 'Seleccione una opción' },
    selectCity: { en: 'Select your city', es: 'Seleccione su ciudad' },
    otherCity: { en: 'Other Central Ohio location', es: 'Otra ubicación en el centro de Ohio' },
    namePh: { en: 'Jane Smith', es: 'María García' },
    detailsPh: {
      en: 'Rooms or building type, square footage, surfaces, colors…',
      es: 'Habitaciones o tipo de edificio, pies cuadrados, superficies, colores…',
    },
    errors: {
      name: { en: 'Please enter your name.', es: 'Por favor, ingrese su nombre.' },
      phone: { en: 'Please enter a 10-digit phone number.', es: 'Ingrese un número de teléfono de 10 dígitos.' },
      email: { en: 'Please enter a valid email address.', es: 'Ingrese un correo electrónico válido.' },
      projectType: { en: 'Please choose a project type.', es: 'Seleccione un tipo de proyecto.' },
      location: { en: 'Please choose your project location.', es: 'Seleccione la ubicación del proyecto.' },
    },
    sending: { en: 'Sending request…', es: 'Enviando solicitud…' },
    noObligation: { en: 'No obligation. We never share your information.', es: 'Sin compromiso. Nunca compartimos su información.' },
    errorMsg: {
      en: 'Something went wrong sending your request. Please try again or call {phone}.',
      es: 'Hubo un problema al enviar su solicitud. Intente de nuevo o llame al {phone}.',
    },
    successTitle: { en: 'Thank you, {name}!', es: '¡Gracias, {name}!' },
    successBody: {
      en: 'Your estimate request is in. A Win21der project manager will call you at {phone} within one business day.',
      es: 'Recibimos su solicitud. Un gerente de proyectos de Win21der le llamará al {phone} en un día hábil.',
    },
    another: { en: 'Submit another request', es: 'Enviar otra solicitud' },
    infoLabel: { en: 'Contact information', es: 'Información de contacto' },
    callOrText: { en: 'Call or text', es: 'Llame o envíe un mensaje' },
    infoTagline: {
      en: 'Professional Painting Services — Home & Business',
      es: 'Servicios Profesionales de Pintura — Hogar y Negocio',
    },
    office: { en: 'Office', es: 'Oficina' },
    hours: { en: 'Hours', es: 'Horario' },
    emailLabel: { en: 'Email', es: 'Correo' },
    areas: { en: 'Service areas', es: 'Áreas de servicio' },
  },

  footer: {
    tagline: { en: 'Professional Painting Services', es: 'Servicios Profesionales de Pintura' },
    about: {
      en: 'Commercial and residential painting for homes, offices, warehouses, churches, schools, and retail spaces in Columbus, Ohio.',
      es: 'Pintura comercial y residencial para hogares, oficinas, almacenes, iglesias, escuelas y comercios en Columbus, Ohio.',
    },
    quickLinks: { en: 'Quick Links', es: 'Enlaces' },
    services: { en: 'Services', es: 'Servicios' },
    contact: { en: 'Contact', es: 'Contacto' },
    languages: { en: 'Languages', es: 'Idiomas' },
    rights: { en: '© 2026 Win21der. All rights reserved.', es: '© 2026 Win21der. Todos los derechos reservados.' },
    hoursShort: { en: 'Mon–Sun, 9am–7pm', es: 'Lun–Dom, 9am–7pm' },
  },
};
